var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g({staticClass:"rmp-text-btn text-body-2 d-inline-block",attrs:{"retain-focus-on-click":"","plain":"","text":"","to":_vm.to,"href":_vm.href,"color":_vm.color,"data-cy":"submit","loading":_vm.loading,"disabled":_vm.disabled}},_vm.$listeners),[_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }